import { Attr, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class SourceGroup extends ApplicationRecord {
  static jsonapiType = "source_groups";

  @Attr({ persist: false }) createdAt: string;

  @Attr() logoUrl: string;

  @Attr({ persist: false }) medium: string;

  @Attr() name: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default SourceGroup;
